export default [
    {
        title: "Avaliação de Perfil",
        questions: [
            {
                label: "Perfil possui proprietário?",
                value: 1,
            },
            {
                label: "Foto de Perfil?",
                value: 1,
            },
            {
                label: "Foto de Capa?",
                value: 1,
            },
            {
                label: "Fotos Internas?",
                value: 2,
            },
            {
                label: "Fotos Externas?",
                value: 2,
            },
            {
                label: "Descrição da Empresa?",
                value: 1,
            },
            {
                label: "Endereço correto e atualizado?",
                value: 2,
            },
            {
                label: "Telefone principal para contato?",
                value: 1,
            },
            {
                label: "Horário de Funcionamento?",
                value: 2,
            },
        ],
    },
    {
        title: "Avaliação de Informações Adicionais",
        questions: [
            {
                label: "Possui site?",
                value: 1,
            },
            {
                label: "Descrição dos produtos?",
                value: 1,
            },
            {
                label: "Descrição dos serviços?",
                value: 1,
            },
            {
                label: "Possui etiquetas?",
                value: 1,
            },
            {
                label: "URL de agendamento?",
                value: 1,
            },
            {
                label: "Nome curto do perfil?",
                value: 1,
            },
            {
                label: "Possui outras fotos?",
                value: 1,
            },
            {
                label: "Possui vídeos?",
                value: 1,
            },
            {
                label: "Possui vídeo 360º?",
                value: 2,
            },
        ],
    },
    {
        title: "Avaliação de Interações com o Usuário",
        questions: [
            {
                label: "Recebeu avaliações?",
                value: 2,
            },
            {
                label: "Recebe avaliações com frequência?",
                value: 1,
            },
            {
                label: "Responde às avaliações?",
                value: 2,
            },
            {
                label: "Possui avaliações negativas?",
                value: 1,
            },
            {
                label: "Faz postagens?",
                value: 1,
            },
            {
                label: "Tem promoções ativas?",
                value: 2,
            },
            {
                label: "Tem eventos ativos?",
                value: 2,
            },
            {
                label: "Possui fotos dos clientes?",
                value: 1,
            },
            {
                label: "Gerencia fotos de clientes?",
                value: 2,
            },
        ],
    },
];
